import Vue from 'vue'
import Meta from 'vue-meta'
import { createRouter } from './router.js'
import NoSsr from './components/no-ssr.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_head_05b4b43d from 'nuxt_plugin_head_05b4b43d' // Source: ./purchase-quote/head.js (mode: 'all')
import nuxt_plugin_plugin0_4dd95747 from 'nuxt_plugin_plugin0_4dd95747' // Source: ./purchase-quote/plugin-0.js (mode: 'client')
import nuxt_plugin_plugin1_4dd9cba6 from 'nuxt_plugin_plugin1_4dd9cba6' // Source: ./purchase-quote/plugin-1.js (mode: 'all')
import nuxt_plugin_plugin2_4dda4005 from 'nuxt_plugin_plugin2_4dda4005' // Source: ./purchase-quote/plugin-2.js (mode: 'all')
import nuxt_plugin_plugin3_4ddab464 from 'nuxt_plugin_plugin3_4ddab464' // Source: ./purchase-quote/plugin-3.js (mode: 'all')
import nuxt_plugin_plugin4_4ddb28c3 from 'nuxt_plugin_plugin4_4ddb28c3' // Source: ./purchase-quote/plugin-4.js (mode: 'server')
import nuxt_plugin_plugin5_4ddb9d22 from 'nuxt_plugin_plugin5_4ddb9d22' // Source: ./purchase-quote/plugin-5.js (mode: 'client')
import nuxt_plugin_plugin6_4ddc1181 from 'nuxt_plugin_plugin6_4ddc1181' // Source: ./purchase-quote/plugin-6.js (mode: 'all')
import nuxt_plugin_plugin7_4ddc85e0 from 'nuxt_plugin_plugin7_4ddc85e0' // Source: ./purchase-quote/plugin-7.js (mode: 'all')
import nuxt_plugin_plugin8_4ddcfa3f from 'nuxt_plugin_plugin8_4ddcfa3f' // Source: ./purchase-quote/plugin-8.js (mode: 'all')
import nuxt_plugin_plugin9_4ddd6e9e from 'nuxt_plugin_plugin9_4ddd6e9e' // Source: ./purchase-quote/plugin-9.js (mode: 'all')
import nuxt_plugin_plugin10_6d5faff8 from 'nuxt_plugin_plugin10_6d5faff8' // Source: ./purchase-quote/plugin-10.js (mode: 'all')
import nuxt_plugin_plugin11_6d602457 from 'nuxt_plugin_plugin11_6d602457' // Source: ./purchase-quote/plugin-11.js (mode: 'all')
import nuxt_plugin_plugin12_6d6098b6 from 'nuxt_plugin_plugin12_6d6098b6' // Source: ./purchase-quote/plugin-12.js (mode: 'all')
import nuxt_plugin_plugin13_6d610d15 from 'nuxt_plugin_plugin13_6d610d15' // Source: ./purchase-quote/plugin-13.js (mode: 'all')
import nuxt_plugin_plugin14_6d618174 from 'nuxt_plugin_plugin14_6d618174' // Source: ./purchase-quote/plugin-14.js (mode: 'all')
import nuxt_plugin_plugin15_6d61f5d3 from 'nuxt_plugin_plugin15_6d61f5d3' // Source: ./purchase-quote/plugin-15.js (mode: 'all')
import nuxt_plugin_plugin16_6d626a32 from 'nuxt_plugin_plugin16_6d626a32' // Source: ./purchase-quote/plugin-16.js (mode: 'all')
import nuxt_plugin_plugin17_6d62de91 from 'nuxt_plugin_plugin17_6d62de91' // Source: ./purchase-quote/plugin-17.js (mode: 'all')
import nuxt_plugin_plugin18_6d6352f0 from 'nuxt_plugin_plugin18_6d6352f0' // Source: ./purchase-quote/plugin-18.js (mode: 'all')
import nuxt_plugin_plugin19_6d63c74f from 'nuxt_plugin_plugin19_6d63c74f' // Source: ./purchase-quote/plugin-19.js (mode: 'all')
import nuxt_plugin_plugin20_6d6dc779 from 'nuxt_plugin_plugin20_6d6dc779' // Source: ./purchase-quote/plugin-20.js (mode: 'all')
import nuxt_plugin_plugin21_6d6e3bd8 from 'nuxt_plugin_plugin21_6d6e3bd8' // Source: ./purchase-quote/plugin-21.js (mode: 'all')
import nuxt_plugin_plugin22_6d6eb037 from 'nuxt_plugin_plugin22_6d6eb037' // Source: ./purchase-quote/plugin-22.js (mode: 'all')
import nuxt_plugin_plugin23_6d6f2496 from 'nuxt_plugin_plugin23_6d6f2496' // Source: ./purchase-quote/plugin-23.js (mode: 'all')
import nuxt_plugin_plugin24_6d6f98f5 from 'nuxt_plugin_plugin24_6d6f98f5' // Source: ./purchase-quote/plugin-24.js (mode: 'all')

// Component: <NoSsr>
Vue.component(NoSsr.name, NoSsr)

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>`
Vue.component(Nuxt.name, Nuxt)

// vue-meta configuration
Vue.use(Meta, {
  keyName: 'head', // the component option name that vue-meta looks for meta info on.
  attribute: 'data-n-head', // the attribute name vue-meta adds to the tags it observes
  ssrAttribute: 'data-n-head-ssr', // the attribute name that lets vue-meta know that meta info has already been server-rendered
  tagIDKeyName: 'hid' // the property name that vue-meta uses to determine whether to overwrite or append a tag
})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    router,
    store,
    nuxt: {
      defaultTransition,
      transitions: [ defaultTransition ],
      setTransitions(transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [ transitions ]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },
      err: null,
      dateErr: null,
      error(err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        const nuxt = this.nuxt || this.$options.nuxt
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) ssrContext.nuxt.error = err
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    store,
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  const inject = function (key, value) {
    if (!key) throw new Error('inject(key, value) has no key provided')
    if (typeof value === 'undefined') throw new Error('inject(key, value) has no value provided')
    key = '$' + key
    // Add into app
    app[key] = value

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) return
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Vue.prototype.hasOwnProperty(key)) {
        Object.defineProperty(Vue.prototype, key, {
          get() {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Plugin execution

  if (typeof nuxt_plugin_head_05b4b43d === 'function') {
    await nuxt_plugin_head_05b4b43d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plugin0_4dd95747 === 'function') {
    await nuxt_plugin_plugin0_4dd95747(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin1_4dd9cba6 === 'function') {
    await nuxt_plugin_plugin1_4dd9cba6(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin2_4dda4005 === 'function') {
    await nuxt_plugin_plugin2_4dda4005(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin3_4ddab464 === 'function') {
    await nuxt_plugin_plugin3_4ddab464(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_plugin4_4ddb28c3 === 'function') {
    await nuxt_plugin_plugin4_4ddb28c3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plugin5_4ddb9d22 === 'function') {
    await nuxt_plugin_plugin5_4ddb9d22(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin6_4ddc1181 === 'function') {
    await nuxt_plugin_plugin6_4ddc1181(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin7_4ddc85e0 === 'function') {
    await nuxt_plugin_plugin7_4ddc85e0(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin8_4ddcfa3f === 'function') {
    await nuxt_plugin_plugin8_4ddcfa3f(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin9_4ddd6e9e === 'function') {
    await nuxt_plugin_plugin9_4ddd6e9e(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin10_6d5faff8 === 'function') {
    await nuxt_plugin_plugin10_6d5faff8(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin11_6d602457 === 'function') {
    await nuxt_plugin_plugin11_6d602457(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin12_6d6098b6 === 'function') {
    await nuxt_plugin_plugin12_6d6098b6(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin13_6d610d15 === 'function') {
    await nuxt_plugin_plugin13_6d610d15(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin14_6d618174 === 'function') {
    await nuxt_plugin_plugin14_6d618174(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin15_6d61f5d3 === 'function') {
    await nuxt_plugin_plugin15_6d61f5d3(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin16_6d626a32 === 'function') {
    await nuxt_plugin_plugin16_6d626a32(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin17_6d62de91 === 'function') {
    await nuxt_plugin_plugin17_6d62de91(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin18_6d6352f0 === 'function') {
    await nuxt_plugin_plugin18_6d6352f0(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin19_6d63c74f === 'function') {
    await nuxt_plugin_plugin19_6d63c74f(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin20_6d6dc779 === 'function') {
    await nuxt_plugin_plugin20_6d6dc779(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin21_6d6e3bd8 === 'function') {
    await nuxt_plugin_plugin21_6d6e3bd8(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin22_6d6eb037 === 'function') {
    await nuxt_plugin_plugin22_6d6eb037(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin23_6d6f2496 === 'function') {
    await nuxt_plugin_plugin23_6d6f2496(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin24_6d6f98f5 === 'function') {
    await nuxt_plugin_plugin24_6d6f98f5(app.context, inject)
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    app,
    store,
    router
  }
}

export { createApp, NuxtError }
